<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriTanimlama"> Kategori Tanımlama
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriList"> Kategori listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriMenuList"> Kategori menü listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriKaldir"> Kategori kaldır
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kategoriGuncelle"> Kategori güncelle
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import hkategoriService from '../../../WSProvider/HaberKategoriService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataKader = "";
    export default {
        name: "HaberKategoriDetay",
        methods: {

            kategoriTanimlama() {
                let dil = {
                    en: "baslikkk"
                }
                hkategoriService.kategoriTanimlama("deneme haber", "haber deneme", 1, dil);
            },
            kategoriList() {
                hkategoriService.kategoriList();
            },
            kategoriGuncelle() {
                let dil = {
                    en: "baslikkk"
                }
                hkategoriService.kategoriGuncelle(3, "yeni haber", 0,"yenilink", dil);
            },
            kategoriKaldir() {
                hkategoriService.kategoriKaldir("HK-1000");
            },
            kategoriMenuList() {
                hkategoriService.kategoriMenuList();
            },

        }
    }
</script>

<style scoped>

</style>